import type { TServiceProvider } from '@shared/lib/types';

export const ROUTES = {
  root: '/',
  login: '/auth/sso/jwt/login',
  logout: '/auth/sso/jwt/logout',
  forgotPassword: '/password/forgot',
  resetPassword: '/password/reset',
  auth: '/jwt/auth',
  account: '/account',
  totp: '/totp',
  totpVerify: '/totp/verify',
  totpReset: '/totp/reset',
  photo: '/photo',
  generalEdit: '/general/edit',
  credentials: '/credentials',
  editLogin: '/credentials/login/edit',
  confirmEditLogin: '/credentials/login/confirm-edit',
  requestEditPassword: '/credentials/password/request-edit',
  admin: {
    users: '/admin/users',
    user: '/admin/user/[uuid]',
    photo: '/admin/user/[uuid]/photo',
    editServiceInfo: '/admin/user/[uuid]/service-info/edit',
    editGeneral: '/admin/user/[uuid]/general/edit',
    credentials: '/admin/user/[uuid]/credentials',
    loginEdit: '/admin/user/[uuid]/credentials/login/edit',
    passwordEdit: '/admin/user/[uuid]/credentials/password/edit',
    serviceProviders: '/admin/service-providers',
    getShowServiceProviderUrl: (uuid: string, type: TServiceProvider) => `/admin/service-providers/${type}/${uuid}`,
    getNewServiceProviderUrl: (type: TServiceProvider) => `/admin/service-providers/${type}/new`,
    getEditServiceProviderUrl: (uuid: string, type: TServiceProvider) =>
      `/admin/service-providers/${type}/${uuid}/edit`,
  } as const,
} as const;
